import dark from './dark';
import light from './light';

export default {
  dark,
  light,
};
